'use client';

import ErrorComponents from '../components/shared/ErrorComponents';

export default function GlobalError() {
  return <ErrorComponents error="500" />;
}
